import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledParagraphWithVideo } from "./paragraph-with-video.scss";
const ParagraphWithVideo = (props)=>{
    const { title, description, videoSrc } = props;
    return /*#__PURE__*/ _jsxs(StyledParagraphWithVideo, {
        className: "paragraph-with-video",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "paragraph-content-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "paragraph-content-title",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "paragraph-content-description",
                        children: description
                    })
                ]
            }),
            videoSrc && /*#__PURE__*/ _jsx("div", {
                className: "paragraph-video-wrapper",
                children: /*#__PURE__*/ _jsx("video", {
                    className: "pargraph-video-item",
                    src: videoSrc,
                    loop: "true",
                    muted: "true",
                    autoplay: "true"
                })
            })
        ]
    });
};
export default ParagraphWithVideo;
